import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { BasePage } from '../../../../../components/BaseMain';
import { goToAdmin, goToCreateIndex } from '../../../../../router/coordinator';
import {
  AlertMessage,
  EmptyTable,
  FilterContainer,
  HiddenForPermission,
  TitlePages
} from '../../../../../components';
import { useForm } from '../../../../../hooks/useForm';
import { Button, Grid, TextField } from '@mui/material';
import { TableContainer } from '../../../../../components/TableContainer';
import { clearAlertMessage, hasPermission, isDesktop } from '../../../../../utils';
import { DesktopTable } from './TablesComponents/DesktopTable';
import { MobileTable } from './TablesComponents/MobileTable';
import { listAllIndex } from '../../../../../services';
import { GENERIC_ERROR } from '../../../../../utils/constantes';

export function ListIndexPage() {
  const navigate = useNavigate();
  const breadcrumbs = [
    { title: 'Administrativo', functionCoordinator: () => goToAdmin(navigate) },
    { title: 'Índices' }
  ];

  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState({
    title: '',
    message: '',
    severity: 'error'
  });

  const [filters, onChange] = useForm({
    name: ''
  });
  const [debouncedFilter] = useDebounce(filters, 500);

  const [indexes, setIndexes] = useState([]);

  useEffect(async () => await list(), [debouncedFilter]);

  const list = async () => {
    try {
      setLoading(true);

      const result = await listAllIndex(filters);

      setIndexes(result);
      setLoading(false);
    } catch (error) {
      setAlertMessage({ title: error.message || GENERIC_ERROR });
      setLoading(false);
    }
  };

  function TableResponsive() {
    if (!indexes?.length && !loading) {
      return <EmptyTable />;
    }

    if (isDesktop()) {
      return <DesktopTable indexes={indexes} loading={loading} navigate={navigate} />;
    }

    return <MobileTable indexes={indexes} loading={loading} navigate={navigate} />;
  }

  return (
    <BasePage navigate={navigate} breadcrumbs={breadcrumbs}>
      <TitlePages
        title={'Lista de índices cadastrados'}
        textButton={'Cadastrar índice'}
        Icon={AddCircleOutlineIcon}
        onClickButton={() => goToCreateIndex(navigate)}
        keyPermissionButton={'CREATE_INDEX'}
        toHideDivider={!hasPermission('LIST_INDEX')}
      />
      <HiddenForPermission keys="LIST_INDEX">
        <Grid container>
          <AlertMessage
            message={alertMessage.message}
            severity={alertMessage.severity}
            title={alertMessage.title}
            onClose={() => clearAlertMessage(setAlertMessage)}
          />
        </Grid>

        <FilterContainer>
          <Grid item xs={12} lg={3}>
            <TextField label={'Nome'} name={'name'} value={filters.name} onChange={onChange} />
          </Grid>
        </FilterContainer>

        <TableContainer>
          <TableResponsive />
        </TableContainer>

        <div className={'buttonGroup twoButtons'}>
          <Button variant="outlined" onClick={() => goToAdmin(navigate)}>
            Voltar
          </Button>
          <span></span>
        </div>
      </HiddenForPermission>
    </BasePage>
  );
}
